import { Banner, Layout, Page, Link, LegacyCard, Icon, Text, Button, Card, BlockStack, Tabs, Box, Grid, InlineStack, Tag } from "@shopify/polaris";
import { ExternalIcon } from '@shopify/polaris-icons';
import { useState, useEffect } from "react";
import { SkeletonPageSettings } from "./SkeletonPageSettings";
import { moastIconCustom, arvioIconCustom, subscriptionsByAppstleIconCustom } from "../assets/partners";
import { useHostNavigate } from "../hooks";

export function Partners(props) {
    const navigate = useHostNavigate();

    const [loading, setLoading] = useState(true);
    const [redirectUrl, setRedirectUrl] = useState('');

    const tabs = [
        {
            id: 'general',
            content: 'General',
            accessibilityLabel: 'General',
            panelID: 'general-content',
        },
        {
            id: 'billing',
            content: 'Billing',
            panelID: 'billing-content',
        },
        {
            id: 'partners',
            content: 'Partners',
            panelID: 'partners-content',
        }
    ];

    const populateData = async () => {
        props.setIsLoading(true);
        props.setIsLoading(false);
        setLoading(false);
    };

    useEffect(() => {
        document.title = "Partners | Stack Discounts";
        populateData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        loading ?
            <SkeletonPageSettings tabIndex={2} />
            :
            <Page title='Settings'>
                <Box paddingBlockEnd="400">
                    <LegacyCard>
                        <Tabs tabs={tabs} selected={2} onSelect={(index) => {
                            let url = '';
                            switch (index) {
                                case 1:
                                    url = '/settings/billing';
                                    break;
                                case 2:
                                    url = '/settings/partners';
                                    break;
                                case 0:
                                default:
                                    url = '/settings';
                            }
                            setRedirectUrl(url);
                        }} fitted>
                        </Tabs>
                    </LegacyCard>
                </Box>
                <div className="partners-div">
                    <Grid>
                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4 }}>
                            <div className="partner-div" onClick={() => { window.open("https://apps.shopify.com/moast-interactive-ugc?utm_source=stackdiscountspro&utm_medium=partner&utm_campaign=inapp", '_blank'); }}>
                                <LegacyCard sectioned>
                                    <InlineStack gap="400" wrap={false}>
                                        <img alt={"Moast"} className="card-image" src={moastIconCustom} />
                                        <BlockStack gap="200">
                                            <InlineStack gap="200" wrap={false}>
                                                <Text variant="headingMd" as="h2">Moast: Shoppable Video & UGC</Text>
                                                <Box>
                                                    <Icon source={ExternalIcon} tone="subdued" />
                                                </Box>
                                            </InlineStack>
                                            <Text as="p" tone="subdued">Turn Reels, TikToks & UGC into shoppable video widgets on your store in less than 5 mins.</Text>
                                            <p>
                                                <Tag>Social proof</Tag>
                                            </p>
                                        </BlockStack>
                                    </InlineStack>
                                </LegacyCard>
                            </div>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4 }}>
                            <div className="partner-div" onClick={() => { window.open("https://platform.shoffi.app/r/rl_lQwhlZt1", '_blank'); }}>
                                <LegacyCard sectioned>
                                    <InlineStack gap="400" wrap={false}>
                                        <img alt={"Arvio"} className="card-image" src={arvioIconCustom} />
                                        <BlockStack gap="200">
                                            <InlineStack gap="200" wrap={false}>
                                                <Text variant="headingMd" as="h2">Arvio: AI Store Operator</Text>
                                                <Box>
                                                    <Icon source={ExternalIcon} tone="subdued" />
                                                </Box>
                                            </InlineStack>
                                            <Text as="p" tone="subdued">AI finds & fixes pricing, stock, and SEO issues nightly. Edits wait for your approval. 5-day trial.</Text>
                                            <p>
                                                <Tag>Workflow automation</Tag>
                                            </p>
                                        </BlockStack>
                                    </InlineStack>
                                </LegacyCard>
                            </div>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4 }}>
                            <div className="partner-div" onClick={() => { window.open("https://apps.shopify.com/subscriptions-by-appstle?utm_source=stack_discount&utm_medium=referral&utm_campaign=september_campaign&utm_content=appstle_subscription", '_blank'); }}>
                                <LegacyCard sectioned>
                                    <InlineStack gap="400" wrap={false}>
                                        <img alt={"Appstle Subscriptions"} className="card-image" src={subscriptionsByAppstleIconCustom} />
                                        <BlockStack gap="200">
                                            <InlineStack gap="200" wrap={false}>
                                                <Text variant="headingMd" as="h2">Appstle Subscriptions</Text>
                                                <Box>
                                                    <Icon source={ExternalIcon} tone="subdued" />
                                                </Box>
                                            </InlineStack>
                                            <Text as="p" tone="subdued">Appstle helps Shopify brands grow with flexible subscription tools that boost retention and customer loyalty.</Text>
                                            <p>
                                                <Tag>Subscriptions</Tag>
                                            </p>
                                        </BlockStack>
                                    </InlineStack>
                                </LegacyCard>
                            </div>
                        </Grid.Cell>
                    </Grid>
                </div>
            </Page >
    );
}